import { render, staticRenderFns } from "./splitOrderModal.vue?vue&type=template&id=55b43069&scoped=true&"
import script from "./splitOrderModal.vue?vue&type=script&lang=js&"
export * from "./splitOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./splitOrderModal.vue?vue&type=style&index=0&id=55b43069&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b43069",
  null
  
)

export default component.exports